import React from 'react'

import { ConfirmationControlSkeleton } from '../../../../concorde-renderers'
import { SuspendedControl } from '../../SuspendedControl'

/**
 * Renders a Suspense-enabled version of ConfirmationControl.
 */
export const SuspendedConfirmationControl = SuspendedControl(
  React.lazy(() => import('./ConfirmationMessageControl')),
  <ConfirmationControlSkeleton />
)
